import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "table table-sm table-borderless" }

import { format_currency, format_price } from '@/helpers/filters'
import { EVENT_NAME__PRODUCT_PRICES_LOADED } from '@/api/shopping/silpo/ProductsApi'
import { computed, onBeforeMount, reactive, watch } from 'vue'
import { ListResponse, Price, ProductPrice } from '@/types/api'
import { silpoProductsApi } from '@/di/api'
import eventBus from '@/di/eventBus'
import { useStore } from "vuex";

interface Props {
  visible?: boolean,
  vendorCode: number,
  date: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SilpoProductPricesInStores',
  props: {
    visible: { type: Boolean, default: false },
    vendorCode: null,
    date: null
  },
  emits: ["loadingStart", "loadingFinish"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'loadingStart'): void,
  (e: 'loadingFinish'): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, vendorCode: number, date: string };

const store = useStore()





const lock = reactive<{ isLoading: boolean }>({ isLoading: false })

const data = reactive<{ pricesInStores: ProductPrice[] }>({ pricesInStores: [] })

watch(() => props.visible, async (visible): Promise<void> => {
  if (visible) {
    await loadPrices()
  } else {
    data.pricesInStores = []
  }
})

watch(() => props.vendorCode, (): void => {
  data.pricesInStores = []
})

watch(() => lock.isLoading, (isLoading): void => {
  if (isLoading) {
    emit('loadingStart')
  } else {
    emit('loadingFinish')
  }
})

const favouriteStoreIds = computed(() => store.getters['shopping/silpo/favouriteStores/ids'])

const tableData = computed((): { price: Price, city: string, store: string }[] => {
  return data.pricesInStores
      .filter(({ filial_id }) => favouriteStoreIds.value.includes(filial_id))
      .map(({ price, filial_id }): { price: Price, city: string, store: string } | null => {
        const silpoStore = store.getters['shopping/silpo/stores/storeByFilialId'](filial_id)
        if (!silpoStore) return null

        const city = store.getters['shopping/silpo/cities/storeByCityId'](silpoStore.city_id)
        if (!city) return null

        return {
          price,
          city: city.name,
          store: silpoStore.title
        }
      })
      .filter((_) => !!_)
      .sort((a, b) => (a.city + a.store).localeCompare(b.city + b.store))
})

async function loadPrices (): Promise<void> {
  lock.isLoading = true

  const productPricesInFavouriteStores: ListResponse<ProductPrice>
      = await silpoProductsApi.getProductPrices({
    filter: {
      lager_id: props.vendorCode,
      date: props.date
    }
  })

  if (productPricesInFavouriteStores.items.length < favouriteStoreIds.value.length) {
    const callback = async (): Promise<void> => {
      await loadPrices()
      lock.isLoading = false
    }

    eventBus.$on(EVENT_NAME__PRODUCT_PRICES_LOADED, callback)

    try {
      await silpoProductsApi.loadProductPrices({
        lagerId: props.vendorCode,
        filialIds: favouriteStoreIds.value,
        date: props.date
      })
    } catch (e) {
      eventBus.$off(EVENT_NAME__PRODUCT_PRICES_LOADED, callback)
    }
  } else {
    data.pricesInStores = productPricesInFavouriteStores.items
    lock.isLoading = false
  }
}

onBeforeMount((): void => {
  store.dispatch('shopping/silpo/favouriteStores/init')
  store.dispatch('shopping/silpo/cities/init')
  store.dispatch('shopping/silpo/stores/init')
})


return (_ctx: any,_cache: any) => {
  return (props.visible && data.pricesInStores.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableData), (product) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: `${product.city}-${product.store}`
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("small", null, _toDisplayString(product.city), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("small", null, _toDisplayString(product.store), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("small", null, [
                  (product.price)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_unref(format_price)(product.price.amount)) + " " + _toDisplayString(_unref(format_currency)(product.price.currency)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})